import script from "./company-editing-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./company-editing-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./company-editing-drawer.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__